import cn from 'classnames'
import React, { ReactElement } from 'react'

import style from './SettingsSegmented.style'

export type SettingsSegmentedOption = {
  label: string
  value: string
}

type SettingsSegmentedProps = {
  options: SettingsSegmentedOption[]
  value: string
  onChange: (value: string) => void
  /** Accessible group name. */
  ariaLabel: string
  className?: string
}

/**
 * Neutral pick-one segmented control used by the redesigned Account Settings
 * tiles (EX-40354) — a grey track with a white, subtly-raised selected pill (no
 * blue accents). Mirrors the design-render `Segmented` under its `gf-seg-quiet`
 * override. Each segment is a native `<button aria-pressed>`.
 */
export default function SettingsSegmented(
  props: SettingsSegmentedProps,
): ReactElement {
  const { options, value, onChange, ariaLabel, className = '' } = props

  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn('SettingsSegmented', className)}
      css={style}
    >
      {options.map((option) => {
        const selected = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            className={cn('SettingsSegmented-segment', { selected })}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
